import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import {
  isGa4Enabled,
  isStorefrontAnalyticsPath,
  syncGa4ForPath,
  trackPageView,
} from '@/lib/ga4'

/**
 * Sends GA4 page_view on storefront navigations only.
 * Admin routes disable analytics collection so admin usage is not tracked.
 */
export function AnalyticsRouteTracker() {
  const { pathname, search } = useLocation()
  const lastTrackedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!isGa4Enabled()) return

    void (async () => {
      await syncGa4ForPath(pathname)

      if (!isStorefrontAnalyticsPath(pathname)) {
        lastTrackedRef.current = null
        return
      }

      const path = `${pathname}${search}`
      if (lastTrackedRef.current === path) return
      lastTrackedRef.current = path

      await trackPageView(path)
    })()
  }, [pathname, search])

  return null
}
